import { defineComponent as d, createBlock as r, openBlock as i, withCtx as o, createVNode as m, unref as p, createCommentVNode as a } from "vue";
import s from "../../../icons/generated/IconCross.vue2.js";
import f from "../../../icons/generated/IconDownload.vue2.js";
import "@ds/plugin";
import "@ds/components/AccordionItem";
import "@ds/components/AccordionList";
import "@ds/components/Avatar";
import "@ds/components/Backdrop";
import "@ds/components/Badge";
import "@ds/components/Banner";
import "@ds/components/Breadcrumb";
import "@ds/components/Button";
import "@ds/components/ButtonBase";
import "@ds/components/ButtonCard";
import "@ds/components/ButtonIcon";
import "@ds/components/Card";
import "@ds/components/CardCarousel";
import "@ds/components/CardGrid";
import "@ds/components/Carousel";
import "@ds/components/CategoryCard";
import "@ds/components/Checkbox";
import "@ds/components/ColorSwatch";
import "@ds/components/Container";
import "@ds/components/ContentBlock";
import "@ds/components/CountryFlag";
import "@ds/components/ContextualMenu";
import "@ds/components/Dialog";
import "@ds/components/Divider";
import "@ds/components/Document";
import "@ds/components/DocumentList";
import "@ds/components/Drawer";
import "@ds/components/EditorialCard";
import "@ds/components/Form";
import "@ds/components/HorizontalSeriesBlock";
import "@ds/components/HorizontalSeriesBlockItem";
import "@ds/components/Icon";
import { RevIllustration as b } from "@ds/components/Illustration";
import "@ds/components/IllustrationSource";
import "@ds/components/InfoBlock";
import "@ds/components/InputAutocomplete";
import "@ds/components/InputDate";
import "@ds/components/InputFileUpload";
import "@ds/components/InputMultiSelect";
import "@ds/components/InputNumber";
import "@ds/components/InputPassword";
import "@ds/components/InputPhone";
import "@ds/components/InputSelect";
import "@ds/components/InputSelectSearchable";
import "@ds/components/InputText";
import "@ds/components/InputTextarea";
import "@ds/components/InputVirtual";
import "@ds/components/Link";
import "@ds/components/List";
import "@ds/components/ListItemBase";
import "@ds/components/ListItemInteractive";
import "@ds/components/ListItemStatic";
import "@ds/components/LoadingScreen";
import "@ds/components/MediaViewer";
import "@ds/components/Message";
import "@ds/components/ModalBase";
import "@ds/components/Pagination";
import "@ds/components/Picker";
import "@ds/components/PitchBlock";
import "@ds/components/Popover";
import "@ds/components/Portal";
import "@ds/components/Radio";
import "@ds/components/RadioBase";
import "@ds/components/Range";
import "@ds/components/Rating";
import "@ds/components/Skeleton";
import "@ds/components/SkipToContent";
import "@ds/components/Slider";
import "@ds/components/Spinner";
import "@ds/components/StatusTracker";
import "@ds/components/Stepper";
import "@ds/components/StickyBar";
import "@ds/components/TabItem";
import "@ds/components/Table";
import "@ds/components/Tabs";
import "@ds/components/Tag";
import "@ds/components/TextList";
import "@ds/components/TextListItem";
import "@ds/components/Toast";
import "@ds/components/Toggle";
import "@ds/components/Tooltip";
import "@ds/translations";
import "@ds/utils";
import "@ds/tracking/tracking";
import l from "./DocumentSmallAvatar.vue2.js";
import c from "./DocumentSmallBase.vue2.js";
const to = /* @__PURE__ */ d({
  name: "DocumentDefaultSmall",
  __name: "DocumentDefaultSmall",
  props: {
    name: {},
    url: {},
    deletable: { type: Boolean },
    thumbnail: { type: Boolean },
    downloadButtonAriaLabel: {},
    deleteButtonAriaLabel: {}
  },
  emits: ["delete"],
  setup(B, { emit: n }) {
    const u = n;
    return (t, e) => (i(), r(c, {
      "button-attrs": {
        target: "_blank",
        to: t.url
      }
    }, {
      avatar: o(() => [
        t.url && !t.deletable ? (i(), r(l, {
          key: 0,
          "aria-label": t.downloadButtonAriaLabel,
          download: t.name,
          to: t.url
        }, {
          default: o(() => [
            m(p(f), { size: "16" })
          ]),
          _: 1
        }, 8, ["aria-label", "download", "to"])) : a("", !0),
        t.deletable ? (i(), r(l, {
          key: 1,
          "aria-label": t.deleteButtonAriaLabel,
          onClick: e[0] || (e[0] = (_) => u("delete"))
        }, {
          default: o(() => [
            m(p(s), { size: "16" })
          ]),
          _: 1
        }, 8, ["aria-label"])) : a("", !0)
      ]),
      default: o(() => [
        m(p(b), {
          alt: "",
          height: 64,
          "image-class-names": "size-64 object-cover object-center",
          src: t.url,
          title: t.name,
          width: 64
        }, null, 8, ["src", "title"])
      ]),
      _: 1
    }, 8, ["button-attrs"]));
  }
});
export {
  to as default
};
